import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FileUploadModule } from 'ng2-file-upload';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { NgxEditorModule } from 'ngx-editor';
import { NgxSummernoteModule } from 'ngx-summernote';

import {
  NbActionsModule,
  NbCardModule,
  NbLayoutModule,
  NbMenuModule,
  NbRouteTabsetModule,
  NbSearchModule,
  NbSidebarModule,
  NbTabsetModule,
  NbThemeModule,
  NbUserModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NbListModule,
  NbInputModule,
  NbButtonModule,
  NbSpinnerModule,
  NbSelectModule,
  NbRadioModule,
  NbDatepickerModule,
  NbWindowModule,
  NbIconModule
} from '@nebular/theme';

import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { SearchInputComponent } from './layout/search-input/search-input.component';

import { CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, SafePipe } from '../shared/pipes';

import { DEFAULT_THEME } from '../../assets/scss/theme/theme.default';
import { COSMIC_THEME } from '../../assets/scss/theme/theme.cosmic';
import { CORPORATE_THEME } from '../../assets/scss/theme/theme.corporate';

const BASE_MODULES = [CommonModule, FormsModule, ReactiveFormsModule];

const NB_MODULES = [
  NbCardModule,
  NbLayoutModule,
  NbTabsetModule,
  NbRouteTabsetModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbCheckboxModule,
  NbPopoverModule,
  NbContextMenuModule,
  NgbModule,
  FileUploadModule,
  NbListModule,
  Angular2SmartTableModule,
  NbInputModule,
  NbButtonModule,
  NgxEditorModule,
  NbSpinnerModule,
  NbSelectModule,
  NbRadioModule,
  NbDatepickerModule,
  NbCheckboxModule,
  NgxSummernoteModule,
  NbWindowModule,
  NbIconModule
];

const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  LayoutComponent
];

const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  SafePipe
];

const NB_THEME_PROVIDERS = [
  ...NbThemeModule.forRoot(
    {
      name: 'default',
    },
    [ DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME ],
  ).providers,
  ...NbSidebarModule.forRoot().providers,
  ...NbMenuModule.forRoot().providers,
  ...NbDatepickerModule.forRoot().providers,
  ...NbWindowModule.forRoot().providers,
];

@NgModule({
  imports: [...BASE_MODULES, ...NB_MODULES],
  exports: [...BASE_MODULES, ...NB_MODULES, ...COMPONENTS, ...PIPES],
  declarations: [...COMPONENTS, ...PIPES]
})
export class ThemeModule {
  static forRoot(): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: [...NB_THEME_PROVIDERS],
    };
  }
}
